export const BarCodeIcon = ({
  color = '#FF5000',
  width = 24,
  height
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height ?? width}
      viewBox={`0 0 ${width} ${height ?? width}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.10191 4H21.8981C22.2015 4 22.4771 4.11562 22.6766 4.30185C22.8761 4.48809 23 4.74529 23 5.02845V19.2593C23 19.5424 22.8761 19.7996 22.6766 19.9858C22.4771 20.1721 22.2015 20.2877 21.8981 20.2877H2.10191C1.79853 20.2877 1.52295 20.1721 1.32342 19.9858C1.12388 19.7996 1 19.5424 1 19.2593V5.02845C1 4.74529 1.12388 4.48809 1.32342 4.30185C1.52295 4.11562 1.79853 4 2.10191 4ZM21.8981 4.64167H2.10191C1.98832 4.64167 1.88477 4.68529 1.8095 4.75554C1.73424 4.82578 1.6875 4.92243 1.6875 5.02845V19.2593C1.6875 19.3653 1.73424 19.4619 1.8095 19.5322C1.88477 19.6024 1.98832 19.646 2.10191 19.646H21.8981C22.0117 19.646 22.1152 19.6024 22.1905 19.5322C22.2658 19.4619 22.3125 19.3653 22.3125 19.2593V5.02845C22.3125 4.92243 22.2658 4.82578 22.1905 4.75554C22.1152 4.68529 22.0117 4.64167 21.8981 4.64167Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.09961 5.77344H4.02623V18.5104H3.09961V5.77344Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.82617 5.77344H6.38452V18.5104H4.82617V5.77344Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.93359 5.77344H7.44423V18.5104H6.93359V5.77344Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.21289 5.77344H9.43956V18.5104H8.21289V5.77344Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5575 5.77344H15.6309V18.5104H16.5575V5.77344Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8298 5.77344H13.2715V18.5104H14.8298V5.77344Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7235 5.77344H12.2129V18.5104H12.7235V5.77344Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4454 5.77344H10.2188V18.5104H11.4454V5.77344Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0195 5.77344H17.4828V18.5104H17.0195V5.77344Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2832 5.77344H19.8416V18.5104H18.2832V5.77344Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3906 5.77344H20.9013V18.5104H20.3906V5.77344Z"
        fill={color}
      ></path>
    </svg>
  );
};
